const getters = {
  isRegistered: state => state.webrtc.isRegistered,
  iscalling: state => state.webrtc.iscalling,
  isincall: state => state.webrtc.isincall,
  caseinfoPageId: state => state.caseInfoPage.caseinfoPageId,
  visitedViews: state => state.tagsView.visitedViews,
  menus: state => state.tagsView.menu,
}

export default getters


// WEBPACK FOOTER //
// ./src/store/getters.js